import * as types from "./types";

const mutations = {
    [types.LOADING_BATCH_PRODUCTION](state, value) {
        state.loading = value;
    },
    [types.GET_BATCH_PRODUCTION_LIST](state, batchProductions) {
        state.batchProductions = batchProductions;
    },
    [types.ADD_BATCH_PRODUCTION](state, batchProduction) {        
        state.batchProductions.unshift(batchProduction);
    },
    [types.UPDATE_BATCH_PRODUCTION](state, batchProduction) {        
        const batchProductionsIndex = state.batchProductions.findIndex((x) => x.id === batchProduction.id);
        state.batchProductions[batchProductionsIndex] = batchProduction;        
    },
    [types.REMOVE_BATCH_PRODUCTION](state, id) {        
        state.batchProductions = state.batchProductions.filter((x) => x.id !== id);        
    },
};
export default mutations;